import React, { useState, useEffect } from 'react';
import NavBar from '../../../components/NavBar';
import { FaLocationPin } from 'react-icons/fa6';
/* import { requestMapAtt } from '../../../services/requests'; */
import API_BASE_URL from '../../../services/config/api';
import Cer from '../../../images/Monitoramento/CER.png';
import Upa from '../../../images/Monitoramento/UPA.png';
import Emergencia from '../../../images/Monitoramento/EMERGENCIA.png';
import Hospitais from '../../../images/Monitoramento/HOSPITAIS.png';
import Maternidade from '../../../images/Monitoramento/MATERNIDADE.png';
import Pediatrico from '../../../images/Monitoramento/PEDIATRICO.png';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import Cookies from 'js-cookie';

function Monitoramento() {
	const [showInfo, setShowInfo] = useState(true);
	const [showAlert, setShowAlert] = useState(true);
	const [mapError, setMapError] = useState(false);
	/* 	const [lastAtt, setLastAtt] = useState('Carregando...'); */

	/* const attRequest = async () => {
		const att = await requestMapAtt();
		if (att) {
			setLastAtt(att);
		}
	}; */

	useEffect(() => {
		const localData = Cookies.get('user');
		/* 	attRequest(); */

		if (localData) {
			if (
				JSON.parse(Cookies.get('user')).cargo === 'desenvolvedor' ||
				JSON.parse(Cookies.get('user')).unidade.includes('subhue') ||
				JSON.parse(Cookies.get('user')).unidade.includes('sms') ||
				JSON.parse(Cookies.get('user')).cargo === 'sms'
			) {
				setShowAlert(false);
			}
		}
	}, []);

	return (
		<div className='flex flex-col min-h-screen'>
			<NavBar />
			{showAlert ? (
				<section className='bg-[#004A80] mt-[150px] rounded-md w-[100%] sm:w-[70%] md:w-[60%] lg:w-[50%]  mx-auto my-auto'>
					<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
						<div className='mx-auto max-w-screen-sm text-center'>
							<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold text-primary-600'>
								401
							</h1>
							<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
								Acesso Negado
							</p>
							<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
								Você não possui permissão para acessar este
								campo. Entre em contato com o administrador(a)
								da sua unidade para solicitação de acesso.
							</p>
							<a
								href='/login'
								className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-xl px-5 py-2.5 text-center my-4'>
								<span> Volte para a Tela de Login</span>
							</a>
						</div>
					</div>
				</section>
			) : (
				<div className='flex flex-col min-h-screen'>
					<div className='bg-[#F0F4F8] mt-[80px]  h-[110px] w-full font-inter '>
						<div className='w-full flex  justify-center h-full align-middle items-center text-[#004A80] font-semibold text-[16px] md:text-[32px] p-6 sm:p-0'>
							Monitoramento de Leitos SUBHUE
						</div>
					</div>

					<div className='flex flex-col md:flex-row justify-center md:items-center h-auto w-full gap-10 md:mt-0 font-inter'>
						<div className='text-start p-1 pr-4 w-full md:w-[50%] max-w-[500px] sm:mt-6'>
							<div className='w-full mx-auto md:ml-[40%] md:text-left max-w-[600px] bg-gray rounded-md p-12'>
								<p className='text-[#757575] text-[14px] mb-2 md:text-left'>
									Taxa de ocupação:
								</p>
								<div className='flex flex-col gap-2 text-center md:text-left'>
									<div className='flex items-center text-[14px] text-[#47AD4B] gap-2 font-medium md:justify-start'>
										<FaLocationPin className='text-[15px]' />
										<p className='font-inter text-[13px]'>
											{'<50%'}
										</p>
									</div>
									<div className='flex items-center text-[14px] text-[#ED8338] font-medium gap-2 md:justify-start'>
										<FaLocationPin className='text-[15px]' />
										<p className='font-inter text-[13px]'>
											{'<80%'}
										</p>
									</div>
									<div className='flex items-center text-[14px] text-[#C94444] font-medium gap-2 md:justify-start'>
										<FaLocationPin className='text-[15px]' />
										<p className='font-inter text-[13px]'>
											{'≥80%'}
										</p>
									</div>
								</div>

								<div className='sm:grid gap-4 whitespace-nowrap justify-start mt-10 md:justify-start text-[14px] text-[#858585] font-medium ml-4 md:ml-1 border-t border-gray-300 pt-4 max-w-[200px]'>
									{[
										{ label: 'CER', icon: Cer },
										{ label: 'UPA', icon: Upa },
										{
											label: 'Maternidade',
											icon: Maternidade,
										},
										{
											label: 'Hospital Pediátrico',
											icon: Pediatrico,
										},
										{
											label: 'Hospital Especializado',
											icon: Hospitais,
										},
										{
											label: 'Hospital Emergência',
											icon: Emergencia,
										},
									].map((item, index) => (
										<div
											key={index}
											className='flex items-center gap-x-8'>
											<p className='w-[120px] text-left'>
												{item.label}
											</p>
											<div className='w-[45px] h-[40px] flex justify-center'>
												<img
													alt={`Ícone de ${item.label}`}
													className='w-[30px] h-[24px] object-contain'
													src={item.icon}
												/>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>

						<div className='font-inter text-center flex-grow  sm:mt-12 md:mt-10 lg:mt-8'>
							<div className='w-full md:w-[90%] mx-auto'>
								<div className='flex justify-between rounded-md'>
									<div className='flex justify-start items-center w-full max-w-[89%]'>
										<button
											className={`relative transition-all duration-300 ${
												showInfo ? '' : 'text-[#004A80]'
											}`}
											type='button'
											onClick={() => {
												setShowInfo(!showInfo);
											}}>
											<IoIosInformationCircleOutline />
											<div
												className={`flex justify-start text-[#757575] transition-all h-auto w-[260px] duration-300 absolute border-[1px] border-gray-300 bg-[#E3E3E3] rounded-md  ${
													showInfo
														? 'opacity-0 scale-90 pointer-events-none'
														: 'opacity-100 scale-100'
												}`}
												style={{
													top: 'auto',
													bottom: '100%',
													left: '0',
													transform:
														'translateY(-10px)',
													transition: 'all 0.3s ease',
												}}>
												<div className='w-full p-1 text-start text-[10px]'>
													<div className='font-semibold mb-4'>
														Taxa de Ocupação
														Hospitalar:
														<p className='font-normal'>
															Leitos Ocupados
															/(Leitos
															operacionais)
														</p>
													</div>
													<div className='font-semibold'>
														Taxa de Ocupação
														Emergência:
														<p className='font-normal'>
															Leitos Ocupados
															/(Leitos
															operacionais +
															Leitos Extras)
														</p>
													</div>
												</div>
											</div>
										</button>
									</div>

									{/* 	<p className='text-[12px] text-[#757575] whitespace-nowrap'>
										Última atualização:{' '}
										{lastAtt !== 'Carregando...'
											? lastAtt[0]
												? lastAtt[0][
														'ultima_atualizacao'
												  ]
												: 'Carregando...'
											: 'Carregando...'}
									</p> */}
								</div>
							</div>

							<div className='w-full md:w-[90%] mx-auto bg-[#C4C4C4] rounded-md'>
								{mapError ? (
									<div className='w-full aspect-[16/9] flex flex-col items-center justify-center bg-[#F0F0F0] rounded-md gap-3'>
										<svg
											width='36'
											height='36'
											viewBox='0 0 24 24'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'>
											<rect
												x='3'
												y='5'
												width='18'
												height='14'
												rx='2'
												stroke='#BDBDBD'
												strokeWidth='1.8'
											/>
											<line
												x1='3'
												y1='3'
												x2='21'
												y2='21'
												stroke='#BDBDBD'
												strokeWidth='1.8'
												strokeLinecap='round'
											/>
										</svg>
										<p className='text-[#616161] text-[14px] font-medium'>
											Mapa indisponível no momento
										</p>
										<p className='text-[#9E9E9E] text-[11px] max-w-[220px] text-center leading-relaxed'>
											Não foi possível exibir o conteúdo.
											Tente recarregar a página.
										</p>
									</div>
								) : (
									<iframe
										src={`${API_BASE_URL}/mapa/leitos`}
										className='w-full aspect-[16/9] border-none overflow-hidden rounded-md'
										allowFullScreen
										title='Mapa de Leitos'
										onError={() => setMapError(true)}
									/>
								)}
							</div>
							<div className='w-full md:w-[90%] mx-auto flex justify-end mt-1'>
								<p className='text-[12px] text-[#757575] whitespace-nowrap'>
									Fonte: Plataforma SMS Rio
								</p>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default Monitoramento;
